import React, { Component } from 'react';
import classnames from 'classnames';

class EntityTab extends Component {

  tabType = "ENTITY";

  thisTabClicked = (e) => {
    const { tabClicked } = this.props;
    tabClicked(this.tabType);
  }

  render() {
    
    const { thisTabClicked } = this;
    const { activeTabType } = this.props;
    
    const entityTabClass = classnames({
      "col-sm" : true,
      "list-tab" : true,
      "last-tab" : this.props.isLastTab,
      "active" : activeTabType === this.tabType ? true : false
    });

    return (
      <div className={entityTabClass}
        onClick={thisTabClicked}>
        엔티티
      </div>
    );
  }
}

export default EntityTab;